
import { Log } from '../../core';
const log = Log.getLogger('MultiSceneForApp.multiscene.multiscene.getModeParams');

export default function getModeParams(modeId) {
    let params = {};
    switch (modeId) {
        case 'pano':
            params.navigationMode = 3;
            params.spherePhotoOpacity = 1.0;
            params.pointCloudFreeze = true;
            break;
        case 'pano_points':
            params.navigationMode = 3;
            params.spherePhotoOpacity = 0.5;
            params.pointCloudFreeze = false;
            break;
        case 'points':
            params.navigationMode = 1;
            params.spherePhotoOpacity = 0.0;
            params.pointCloudFreeze = false;
            break;
        default:
            log.warn(`Bad 3D mode "${modeId}"`);
            break;
    }
    return params;
}
